import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation, usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation, usePaymentInstrumentsCreateOtherMutation } from "@/hooks";
import config from "@/lib/config";
import { PAYMENT_METHOD_ID } from "@/lib/constants";
import routes from "@/lib/routes";
import { useCallback, useRef } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
export function useCreatePaymentInstrument(_ref) {
  let {
    creditCard = {},
    other = {}
  } = _ref;
  const [createCreditCardRecaptchaV2] = usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation(creditCard);
  const [createCreditCardRecaptchaV3] = usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation(creditCard);
  const [createOther, {
    data: createOtherData
  }] = usePaymentInstrumentsCreateOtherMutation(other);
  const {
    executeRecaptcha
  } = useGoogleReCaptcha();
  const tdsInfoToken = useRef();
  const tdsInfoTokenKey = useRef();
  const generateTokenCallback = useCallback(async _ref2 => {
    let {
      response,
      recaptchaType,
      recaptchaToken
    } = _ref2;
    if (response.result == "OK") {
      const token = response.tokenResponse.token;
      const tokenKey = response.tokenResponse.tokenKey;
      const successUrl = true && `${window.location.origin}${routes.sbps3dsSuccess}`;
      const cancelUrl = true && `${window.location.origin}`;
      const errorUrl = true && `${window.location.origin}${routes.sbps3dsError}`;
      const payload = (creditCard === null || creditCard === void 0 ? void 0 : creditCard.payload) || {};
      if (recaptchaType === "v2") {
        createCreditCardRecaptchaV2({
          variables: {
            payment_method_id: PAYMENT_METHOD_ID.CREDIT_CARD_3DS,
            replace_flag: false,
            success_url: encodeURIComponent(successUrl),
            cancel_url: encodeURIComponent(cancelUrl),
            error_url: encodeURIComponent(errorUrl),
            token: token,
            token_key: tokenKey,
            tds_info_token: tdsInfoToken.current,
            tds_info_token_key: tdsInfoTokenKey.current,
            tokenPayload: _objectSpread({}, payload),
            recaptchaTokenV2: recaptchaToken
          }
        });
      } else if (recaptchaType === "v3") {
        recaptchaToken = await executeRecaptcha("payment_add");
        createCreditCardRecaptchaV3({
          variables: {
            payment_method_id: PAYMENT_METHOD_ID.CREDIT_CARD_3DS,
            replace_flag: false,
            success_url: encodeURIComponent(successUrl),
            cancel_url: encodeURIComponent(cancelUrl),
            error_url: encodeURIComponent(errorUrl),
            token: token,
            token_key: tokenKey,
            tds_info_token: tdsInfoToken.current,
            tds_info_token_key: tdsInfoTokenKey.current,
            tokenPayload: _objectSpread({}, payload),
            recaptchaTokenV3: recaptchaToken
          }
        });
      }
    } else {
      if (creditCard !== null && creditCard !== void 0 && creditCard.onError) {
        creditCard.onError("入力内容に誤りがあります。");
      }
    }
  }, [createCreditCardRecaptchaV2, createCreditCardRecaptchaV3, executeRecaptcha]);
  const generateTokenCallback3DS = useCallback(response => {
    if (response.result == "OK") {
      const token = response.tokenResponse.tds2infoToken;
      const tokenKey = response.tokenResponse.tds2infoTokenKey;
      tdsInfoToken.current = token;
      tdsInfoTokenKey.current = tokenKey;
    } else {
      if (creditCard !== null && creditCard !== void 0 && creditCard.onError) {
        creditCard.onError("入力内容に誤りがあります。");
      }
    }
  });
  const createPaymentInstrument = useCallback(async data => {
    if (data !== null && data !== void 0 && data.cardNumber) {
      data.cardNumber = data === null || data === void 0 ? void 0 : data.cardNumber.replace(/-/g, "");
    }
    const {
      paymentMethod,
      expirationDate,
      cardNumber,
      cvv,
      firstName,
      lastName,
      mailAddress,
      recaptchaType,
      recaptchaToken
    } = data;
    if (paymentMethod === PAYMENT_METHOD_ID.CREDIT_CARD_3DS) {
      if (recaptchaType !== "v2" && recaptchaType !== "v3") {
        creditCard.onError("recaptchaType is invalid");
      }
      if (typeof com_sbps_system_tds2 != "undefined") {
        com_sbps_system_tds2.generateToken({
          merchantId: config.sbps.merchantId,
          serviceId: config.sbps.serviceId,
          billingLastName: lastName,
          billingFirstName: firstName,
          email: mailAddress
        }, response => generateTokenCallback3DS(response));
      }
      if (typeof com_sbps_system != "undefined") {
        com_sbps_system.generateToken({
          merchantId: config.sbps.merchantId,
          serviceId: config.sbps.serviceId,
          ccNumber: cardNumber,
          ccExpiration: expirationDate,
          securityCode: cvv
        }, response => generateTokenCallback({
          response,
          recaptchaType,
          recaptchaToken
        }));
      }
    } else {
      const successUrl = true && `${window.location.origin}${routes.sbpsSuccess}`;
      const cancelUrl = true && window.location.origin;
      const errorUrl = true && `${window.location.origin}${routes.sbpsError}`;
      const payload = (other === null || other === void 0 ? void 0 : other.payload) || {};
      await createOther({
        variables: {
          payment_method_id: paymentMethod,
          replace_flag: false,
          success_url: encodeURIComponent(successUrl),
          cancel_url: encodeURIComponent(cancelUrl),
          error_url: encodeURIComponent(errorUrl),
          tokenPayload: _objectSpread(_objectSpread({}, payload), {}, {
            paymentMethodId: paymentMethod
          })
        }
      });
    }
  }, [createOther, generateTokenCallback]);
  return {
    createPaymentInstrument,
    createOtherData: createOtherData === null || createOtherData === void 0 ? void 0 : createOtherData.paymentInstrumentsCreateOther
  };
}